













































import { Emit, Inject, VModel, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import ProjectService from "@/entities/project/project.service";

@Component
export default class CreateProjectDialog extends Vue {
  @VModel({ type: Boolean }) dialog!: boolean;
  @Inject() userAdminDataFn;
  @Inject() readonly provincesFn;
  @Inject() readonly projectsFn;

  get roles() {
    return this.userAdminDataFn().roles;
  }

  projectEntity = {
    name: '',
    description: '',
    roles: [],
    province: { id: null },
    period: 0,
  };

  projectPeriods = [
    { id: 0, name: 'Khảo sát' },
    { id: 1, name: 'Dự án' },
  ];

  @Emit()
  onCreateSuccess() {}

  async save() {
    let projectService = new ProjectService();
    let createRS = await projectService.create({
      ...this.projectEntity,
      // roles: this.projectEntity.roles.map(e => ({ id: e })),
    });
    (this.$root as any).$bvToast.toast('Đã tạo thành công dự án ' + createRS.name, {
      toaster: 'b-toaster-top-center',
      title: 'Success',
      variant: 'success',
      solid: true,
      autoHideDelay: 5000,
    });
    this.projectsFn().reload();
    this.onCreateSuccess();
    this.dialog = false;
    this.clear();
  }

  clear() {
    this.projectEntity = {
      name: '',
      description: '',
      roles: [],
      province: { id: null },
      period: 0,
    };
  }
}
